<template>
  <div class="ProjectInfo">
    <ComBox title="出勤实况" :element="element">
      <div class="info" :style="`margin-top: ${changeDevicePixelRatio(24)}px;`">
        <div class="list" :style="`font-size: ${changeDevicePixelRatio(element.style.fontSize)}px;`">
          <div class="item">
            <div class="desc ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.subTitleFontSize)}px;`">在岗人数</div>
            <div class="num ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.fontSize)}px;margin-top: ${changeDevicePixelRatio(10)}px;`">{{ personData.onJobCount }}</div>
          </div>
          <div class="item">
            <div class="desc ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.subTitleFontSize)}px;`">场内人数</div>
            <div class="num ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.fontSize)}px;margin-top: ${changeDevicePixelRatio(10)}px;`">{{ personData.entryPersonAmount }}</div>
          </div>
          <div class="item">
            <div class="desc ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.subTitleFontSize)}px;`">进场人数</div>
            <div class="num ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.fontSize)}px;margin-top: ${changeDevicePixelRatio(10)}px;`">{{ personData.inCount }}</div>
          </div>
          <div class="item">
            <div class="desc ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.subTitleFontSize)}px;`">出场人数</div>
            <div class="num ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.fontSize)}px;margin-top: ${changeDevicePixelRatio(10)}px;`">{{ personData.outCount }}</div>
          </div>
          <div class="item">
            <div class="desc ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.subTitleFontSize)}px;`">考勤率</div>
            <div class="num ellipsis" :style="`font-size: ${changeDevicePixelRatio(element.style.fontSize)}px;margin-top: ${changeDevicePixelRatio(10)}px;`">{{ personData.attendanceRate }}%</div>
          </div>
        </div>
      </div>
    </ComBox>
  </div>
</template>

<script>
import ComBox from '../ComBox.vue'
import { mapState } from 'vuex'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
import { personCount } from '@/api/screen'

export default {
  components: { ComBox },
  props: {
    personData: {
      type: Object,
      default: () => { return {} }
    },
    element: {
      type: Object,
      default: () => {}
    },
    attendanceFactComType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem,
      timeLog: state => state.socket.timeLog,
      canvasStyleData: (state) => state.compose.canvasStyleData
    }),
    numFontSize() {
      const px = Math.ceil(30 / window.devicePixelRatio)
      return px
    }
  },

  created() {
    if (this.attendanceFactComType === 1) {
      this.personCount()
    }
  },

  methods: {
    changeDevicePixelRatio,
    personCount() {
      const form = { projectId: this.projectItem.projectId }
      if (this.attendanceFactComType === 1) {
        form.areaIdList = this.canvasStyleData.areaIdList
      } else {
        form.areaIdList = this.areaIdList
      }
      personCount(form).then((res) => {
        this.personData = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ProjectInfo {
  width: 415px;
  height: 150px;
  overflow: hidden;
  .info{
    margin-top: 24px;
    .list{
      display: flex;
      .item{
        width: 20%;
        text-align: center;
        .desc{
          padding: 2% 4%;
          line-height: 1;
        }
        .num{
          line-height: 1;
          font-size: 30px;
          margin-top: 10px;
          padding: 0 4%;
        }
      }
    }
  }
}
</style>
